(function () {
  'use strict';

  var scheduled = false;

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function nearbyMediaName(element) {
    var container = element.closest('.productView-image, .product-single__media, [data-media-id]');
    var image = container && container.querySelector('img[alt]');
    return image ? cleanText(image.getAttribute('alt')) : '';
  }

  function enhanceVideos(root) {
    root.querySelectorAll('video[controls]').forEach(function (video) {
      if (!video.getAttribute('aria-label') && !video.getAttribute('aria-labelledby')) {
        var mediaName = nearbyMediaName(video);
        video.setAttribute('aria-label', mediaName ? mediaName + ' video' : 'Product video');
      }
    });

    root.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"]').forEach(function (frame) {
      if (!frame.getAttribute('title')) {
        var mediaName = nearbyMediaName(frame);
        frame.setAttribute('title', mediaName ? mediaName + ' video' : 'Product video');
      }
    });

    root.querySelectorAll('.productView-videoPopup a, a.videoPopup-btn').forEach(function (link) {
      if (!link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', 'Play product video');
      }
    });
  }

  function ratingLabel(element) {
    var rating = element.getAttribute('data-rating') || element.getAttribute('data-score');
    var count = element.getAttribute('data-reviews-count') || element.getAttribute('data-count');
    var text = cleanText(element.textContent);

    if (rating) {
      return 'Customer rating: ' + rating + ' out of 5' + (count ? ', ' + count + ' reviews' : '');
    }
    if (text) {
      return 'Customer rating: ' + text;
    }
    return '';
  }

  function enhanceRatings(root) {
    var selector = [
      '.ddreview-star',
      '.spr-badge',
      '.spr-summary-starrating',
      '.spr-review-header-starratings',
      '.stamped-product-reviews-badge',
      '.stamped-starrating'
    ].join(',');

    root.querySelectorAll(selector).forEach(function (rating) {
      var interactive = rating.matches('a, button') || rating.querySelector('a, button');
      var label = ratingLabel(rating);

      if (!label) {
        if (rating.classList.contains('ddreview-star') && !interactive) {
          rating.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      rating.removeAttribute('aria-hidden');
      if (interactive) {
        var control = rating.matches('a, button') ? rating : rating.querySelector('a, button');
        if (control && !control.getAttribute('aria-label')) control.setAttribute('aria-label', label);
      } else if (rating.hasAttribute('onclick')) {
        rating.setAttribute('role', 'button');
        rating.setAttribute('tabindex', '0');
        rating.setAttribute('aria-label', label);
        if (!rating.dataset.accessibilityKeyboardBound) {
          rating.dataset.accessibilityKeyboardBound = 'true';
          rating.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              rating.click();
            }
          });
        }
      } else {
        rating.setAttribute('role', 'img');
        rating.setAttribute('aria-label', label);
      }
    });
  }

  function enhanceReviewRegions(root) {
    root.querySelectorAll('#shopify-product-reviews, #stamped-main-widget, .stamped-main-widget').forEach(function (region) {
      if (!region.getAttribute('role')) region.setAttribute('role', 'region');
      if (!region.getAttribute('aria-label') && !region.getAttribute('aria-labelledby')) {
        region.setAttribute('aria-label', 'Customer reviews');
      }
    });
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    enhanceVideos(scope);
    enhanceRatings(scope);
    enhanceReviewRegions(scope);
  }

  function scheduleEnhancement() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhance(document);
    });
  }

  function init() {
    enhance(document);
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return target && target.closest && target.closest(
          '.ddreview-star, #shopify-product-reviews, #stamped-main-widget, .stamped-main-widget, .productView-images, .productView-videoPopup'
        );
      });
      if (relevant) scheduleEnhancement();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
